/*--------------------------------------------------------------
# Custom scripts for History Carousel block
--------------------------------------------------------------*/

const historySlider = document.querySelectorAll('.history-carousel-block .swiper');
const historySliderNext = document.querySelectorAll('.history-swiper-next');
const historySliderPrev = document.querySelectorAll('.history-swiper-prev');

for( i = 0; i < historySlider.length; i++ ) {
    // loop through every example of the card slider and add a dynamic class
    // then init slider and nav arrows based on that new dynamic class
    historySlider[i].classList.add('swiper-' + i);
    historySliderNext[i].classList.add('history-swiper-next-' + i);
    historySliderPrev[i].classList.add('history-swiper-prev-' + i);


	// add to the Next and Prev button hide-btn-desk class in case there is less than 5 sliders to hide them in desktop
	const scopeSliders = document.querySelectorAll('.history-carousel-block .swiper-' + i +' .swiper-slide');
	let scopeSlidersTotal = scopeSliders.length;
	if( scopeSlidersTotal < 5 ) {
		historySliderNext[i].classList.add('hide-btn-desk');
		historySliderPrev[i].classList.add('hide-btn-desk');
	}

    var initHistorySlider = new Swiper('.history-carousel-block .swiper-' + i, {
        grabCursor: true,
        slidesPerView: 1.1,
        spaceBetween: 24,
        // Navigation arrows
        navigation: {
            nextEl: '.history-swiper-next-' + i,
            prevEl: '.history-swiper-prev-' + i,
        },
        // Responsive breakpoints
        breakpoints: {
            575: {
                slidesPerView: 2.1,
            },
            768: {
                slidesPerView: 3.1,
            },
            992: {
                slidesPerView: 4,
                slidesPerGroup: 4, // how many to slide at a time
            }
        }
    });
}
